<script setup lang="js">

import QuestionService from '@/services/question.service.js';
import ErrorUtils from '@/utils/error.utils.js';
import { ref } from 'vue';

const isGeneratingDescription = ref(false);
const descriptionError = ref('');


const props = defineProps([
  'hideSupportImages', 'supportImagesDialogVisible', 'selectedSupportImagesFiles',
  'closeSupportImagesDialog', 'acceptImageTypes', 'invalidFileTypeMessage', 
  'maxFileSize', 'invalidFileSizeMessage', 'onSupportImagesSelect', 
  'saveSupportImages', 'supportImagesErrorMessage'
])

const onSupportImagesSelect = (event) => {
  try {
    const file = event.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result;

        const description = props.selectedSupportImagesFiles.length ? props.selectedSupportImagesFiles[0].description : '';
        const source = props.selectedSupportImagesFiles.length ? props.selectedSupportImagesFiles[0].source : '';

        props.selectedSupportImagesFiles[0] = {
          file: file,
          name: file.name,
          type: file.type,
          base64: base64String,
          description: description,
          source: source
        };
      };
      reader.readAsDataURL(file);
    }
  } catch (e) {
    ErrorUtils.handleError(e);
  }
}

const removeImage = () => {
  try {
    props.selectedSupportImagesFiles[0] = {
      file: null,
      base64: null,
      description: null,
      source: null
    };
  } catch (e) {
    ErrorUtils.handleError(e);
  }
}

// Funcionalidade de gerar descrição de imagem desativada
// const generateDescription = async () => {
//   try {
//     if (!props.selectedSupportImagesFiles[0].base64) {
//       descriptionError.value = 'Nenhuma imagem selecionada para gerar descrição.';
//       return;
//     }
//
//     isGeneratingDescription.value = true;
//     descriptionError.value = '';
//
//     const response = await QuestionService.generateImageDescription(
//       props.selectedSupportImagesFiles[0].base64
//     );
//
//     if (response && response.data && response.data.description) {
//       props.selectedSupportImagesFiles[0].description = response.data.description;
//     } else {
//       descriptionError.value = 'Não foi possível gerar a descrição da imagem.';
//     }
//   } catch (e) {
//     descriptionError.value = 'Erro ao gerar descrição da imagem. Tente novamente.';
//     ErrorUtils.handleError(e);
//   } finally {
//     isGeneratingDescription.value = false;
//   }
// }


</script>

<template>
  <Dialog id="supportImagesDialog"
          header="Defina a imagem de suporte"
          :visible="props.supportImagesDialogVisible"
          @update:visible="props.hideSupportImages"
          modal
          style="width: 50vw; min-height: 300px;">
    <div class="w-full flex justify-content-center direction-column">
      <div>
        <div v-if="props.selectedSupportImagesFiles[0].base64" class="flex justify-content-center overlay-container">
          <img 
            :src="props.selectedSupportImagesFiles[0].base64 || ''"
            :alt="props.selectedSupportImagesFiles[0].name || 'Imagem de suporte'"
            style="width: calc(100% - 33px)"
          />
          <div class="overlay-remove flex justify-content-center align-items-center">
            <i class="pi pi-trash" 
              style="font-size: 2rem"
              @click="removeImage"
            />
          </div>
        </div>

        <FileUpload 
          id="supportImages"
          name="supportImages[]"
          mode="basic"
          chooseLabel="Selecione uma imagem"
          :accept="props.acceptImageTypes"
          :invalidFileTypeMessage="props.invalidFileTypeMessage"
          :maxFileSize="props.maxFileSize"
          :invalidFileSizeMessage="props.invalidFileSizeMessage"
          customUpload
          v-else
          @select="props.onSupportImagesSelect($event)"
          style="width: 250px !important"
          class="w-12 mt-1"
        >
          <template #filelabel>
            <span>Nenhum arquivo selecionado.</span>
          </template>
        </FileUpload>
      </div>

      <Divider />

      <div class="w-full">
        <div class="w-full">
          <div class="flex justify-content-between align-items-center mb-2">
            <label for="supportImageDescription">Descrição:</label>
            <!-- <Button 
              v-if="props.selectedSupportImagesFiles[0].base64"
              label="Gerar descrição"
              icon="pi pi-magic-wand"
              size="small"
              severity="primary"
              :loading="isGeneratingDescription"
              @click="generateDescription"
              class="p-button-sm"
            /> -->
          </div>

          <Textarea 
            id="supportImageDescription"
            rows="5"
            v-model="props.selectedSupportImagesFiles[0].description"
            class="w-full"
            :disabled="isGeneratingDescription"
          />
          <small v-if="descriptionError" class="text-red-500 mt-1">{{ descriptionError }}</small>
        </div>

        <div class="w-full mt-3">
          <label for="supportImageSource">Fonte:</label>
          <InputText 
            id="supportImageSource"
            v-model="props.selectedSupportImagesFiles[0].source"
            class="w-full mt-1"
          />
        </div>
      </div>
    </div>

    <div class="w-full mt-3 flex justify-content-end align-items-center">
      <span v-if="props.supportImagesErrorMessage" class="p-error mr-3">{{ props.supportImagesErrorMessage }}</span>

      <Button 
        id="saveSupportImages"
        label="Salvar"
        icon="pi pi-save"
        v-if="props.selectedSupportImagesFiles.length"
        @click="props.saveSupportImages()"
      />
    </div>
  </Dialog>
</template>

<style scoped>
.overlay-container {
  position: relative;
}

.overlay-remove {
  position: absolute;
  bottom: 0;
  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5);
  color: #f1f1f1;
  width: calc(100% - 33px);
  height: 100%;
  transition: .2s ease;
  opacity:0;
  font-size: 20px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

</style>